import PortflioTable from './PortfolioTable.vue';
import PortflioOptionTable from './PortfolioOptionTable.vue';
import PortflioHistory from './PortfolioHistory.vue';
import PortflioHistoryDates from './PortfolioHistoryDates.vue';
import PortflioHistoryTable from './PortfolioHistoryTable.vue';
import WaitIndicator from "@/components/Common/WaitIndicator";
import LinkToTradespoon from '@/components/LinkToTradespoon.vue'
import LiveTradingRoomRecordings from './LiveTradingRoomRecordings.vue';
import vue from 'vue'
import axios from 'axios'
import { clearCookie, getCookie, setCookie } from '../../utils/cookies';
import { formatDateQuery, formatDate2 } from '../../utils/formatters'
import EliteOrdersBlock from '../../components/Orders/EliteOrdersBlock.vue'
import PositionBlock from '../../components/Positions/PositionBlock.vue'
import EliteSMSAlerts from './EliteSMSAlerts.vue'
import AiAnalysis from './AiAnalysis.vue'
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const GUIDE_COOKIE = 'PORTF_GUIDE_SHOWN';
export default vue.extend({
    name: 'PortflioPage',
    components: {
        PortflioTable,
        PortflioOptionTable,
        WaitIndicator,
        LinkToTradespoon,
        PortflioHistory,
        PortflioHistoryDates,
        PortflioHistoryTable,
        LiveTradingRoomRecordings,
        EliteOrdersBlock,
        PositionBlock,
        EliteSMSAlerts,
        AiAnalysis
    },
    props: {
        portfolio: Object,
        items: Array,
        dayHistory: Array,
        trialInfo: Object,
        tabInfo: Object,
        userInfo: Object,
        loadStockRangeData: Function,
    },
    async mounted() {

        const {
            width
        } = this.$refs.container.getBoundingClientRect();

        this.width = width;
        this.$tours['YTour'].start();
        const rsp = await axios.get('/json/portfolio.json');
        this.config = rsp.data;
        this.links = this.config.links;
        if(this.config.level) {
            this.level = parseFloat(this.config.level);
        }

        const help = this.config.helps.find((help) => {            
            return help.portfolio === this.portfolio.slug;
        })

        if (help) {
            this.cards = help.cards;
        }

        if (this.shouldShowGuide()) {
            this.showGuide();
            this.setSkipGuide();
        }

        const resizeHandler = entries => {
            for (let entry of entries) {
                this.width = entry.contentRect.width;
            }
        };
        if (window.ResizeObserver) {
            const mo = new ResizeObserver(resizeHandler);

            mo.observe(this.$refs.container);
        }
        $('#video .mediaTabsSlick').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $('.arrow-wrapper0'),
            appendDots: $('.dots-wrapper0'),
            dots: true,
            customPaging: function customPaging(slider, i) {
                return '<span><strong>' + (i + 1) + '</strong></span><span class="small px-1"> of </span><span> ' + slider.slideCount + '</span>';
            }

        });
        $('#guides .mediaTabsSlick').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            appendArrows: $('.arrow-wrapper1'),
            appendDots: $('.dots-wrapper1'),
            customPaging: function customPaging(slider, i) {
                return '<span><strong>' + (i + 1) + '</strong></span><span class="small px-1"> of </span><span> ' + (slider.slideCount / 3) + '</span>';
            }

        });
        $('a[data-toggle="tab"]').on('click', function(e) {
            console.log(document.querySelectorAll('.mediaTabsSlick')[0].slick);
            document.querySelectorAll('.mediaTabsSlick')[0].slick.setPosition();
        });
    },
    data() {
        return {
            config: null,
            symbols: '',
            selected: null,
            assetType: null,
            steps: [],
            links: [],
            width: 1110,
            selected_dates: [],
            tabs: [],
            current: 0,
            currentDate: null,
            refresh: true,
            levels: false,
            historicalQuotes: false,
            cards: [],
            level: 0.02,
        }
    },
    computed: {
        currentTitle() {
            return formatDate2(this.currentDate)
        }
    },
    methods: {
        tabsActivate(currentTabs) {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    document.querySelectorAll('.mediaTabsSlick').forEach((slick) => {
                        slick.slick.setPosition();
                    });
                });
            });
        },
        tabsUpdated(currentTabs) {
            this.tabs = currentTabs;
            if (this.currentTitle) {
                this.current = this.tabs.findIndex(e => e.title == this.currentTitle);                
            }            
        },
        closeTab(date) {
            this.selected_dates = this.selected_dates.filter(e => e.date != date)
        },
        tabsInput(index) {
            if(index > 1) {
                this.levels = false;
            }
            else {
                this.levels = true;
            }
        },
        async loadPortfolioHistory(date, histQuotes) {

            const d = date.getTime();

            this.$emit('loading', true);

            const idx = this.selected_dates.findIndex(e => e.date.getTime() === d)
            let query = '/api/portfolio/' + this.portfolio.id + '/history/' + formatDateQuery(date);
            if (histQuotes)
                query += '?historicalQuotes=true'
            const e = await axios.get(query);

            if (e.data.responseCode == 50) {
                this.page = 'root';
                this.$emit('fail', 'Data is not available for ' + date)
                return;
            }

            const updatedVal = { actions: e.data.payload, date: date, historicalQuotes: histQuotes }
            if (idx > -1) {
                this.$set(this.selected_dates, idx, updatedVal)
            } else
                this.selected_dates.push(updatedVal);

            this.currentDate = date

            this.$emit('loading', false);
        },
        updateSel(histChecked) {

            this.historyRefresh({ portfolio: this.portfolio, date: this.currentDate, historicalQuotes: histChecked })
        },
        async portfolioUp(e) {  
            this.$emit('loading', true);
            await this.loadStockRangeData(this.portfolio.id, 'up', this.level);
            this.$emit('loading', false);          
        },
        async portfolioDown(e) {     
            this.$emit('loading', true);
            await this.loadStockRangeData(this.portfolio.id, 'down', this.level);
            this.$emit('loading', false);        
        },
        async historyRefresh(e) {

            await this.loadPortfolioHistory(e.date, e.historicalQuotes)

            this.page = 'portfolio';
            this.$emit('loading', false);
        },
        handleCb(cb) {
            this[cb]();
        },
        shouldShowGuide() {
            return getCookie(GUIDE_COOKIE) !== 'true';
        },
        showGuide() {
            this.config.tour.forEach(item => {
                item.header.title = item.header.title.replace('{{title}}', this.portfolio.title);
            });
            this.steps = this.config.tour;
            this.$refs["vtour"].start();
        },
        setSkipGuide() {
            setCookie(GUIDE_COOKIE, 'true');
        }

    }
});